import { useEffect, useRef, useState } from "react";
import { Spinner } from "components/atoms/Icon";
import "./LoadingOverlay.scss";
import classNames from "classnames";

interface IProps {
  isLoading: boolean;
  children: any;
  theme?: "light" | "dark";
  minDisplayMs?: number;
}

export const LoadingOverlay = ({ isLoading, children, theme, minDisplayMs = 0 }: IProps) => {
  const [showSpinner, setShowSpinner] = useState(isLoading);
  const loadStartRef = useRef<number | null>(null);

  useEffect(() => {
    if (isLoading) {
      loadStartRef.current = Date.now();
      setShowSpinner(true);
    } else if (loadStartRef.current && minDisplayMs > 0) {
      const elapsed = Date.now() - loadStartRef.current;
      const remaining = minDisplayMs - elapsed;
      if (remaining > 0) {
        const timer = setTimeout(() => setShowSpinner(false), remaining);
        return () => clearTimeout(timer);
      }
      setShowSpinner(false);
    } else {
      setShowSpinner(false);
    }
  }, [isLoading, minDisplayMs]);

  return (
    <div className="loading-overlay-container">
      {showSpinner && (
        <div
          className={classNames({
            "loading-overlay": true,
            "dark-opacity": theme === "dark",
          })}
        >
          <Spinner theme={theme} />
        </div>
      )}
      {children}
    </div>
  );
};
